import { IAppState } from 'models/store.models'
import { ICustomLanding } from 'models/landings.custom.model'

export const selectCustomLandings = (state: IAppState): ICustomLanding[] =>
  state.customLandings.landings
export const selectCustomLandingsCount = (state: IAppState): number =>
  state.customLandings.landingsCount
export const selectCustomLandingsSearchString = (state: IAppState): string =>
  state.customLandings.searchString
